import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
  setItemNameLat,
  setItemNameTranslit,
} from '@/modules/Dictionary/__form/item';
import FNumber from '@/plugins/form/FNumber';

export default class DictionaryRoomTypeForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'roomType';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)({ length: 200 });
    setItemNameLat.bind(this)({ length: 200 });
    setItemNameTranslit.bind(this)({ length: 200 });
    setItemCode.bind(this)();
    this.setItemPlaces();
    this.setItemPlacesExt();
  }

  setItemPlaces() {
    this.places = new FNumber({
      name: 'Places',
      label: 'Основных мест',
    });
    this.setItem('places', this.places);
  }

  setItemPlacesExt() {
    this.placesExt = new FNumber({
      name: 'PlacesExt',
      label: 'Дополнительных мест',
    });
    this.setItem('placesExt', this.placesExt);
  }
}
